import { ValidationErrors } from '@angular/forms'

const CLONE_PERSONA_ERROR = 'Could not clone persona. Please try again.'

export class PersonaModel {
  /**
   * @param body - Parsed `error.error` (or equivalent) from the HTTP response
   * @param field - Control / API key, e.g. `'name'`
   */
  public static validationErrorsFromFieldMessages(body: unknown, field: string): ValidationErrors | null {
    const record = body && typeof body === 'object' && !Array.isArray(body) ? (body as Record<string, unknown>) : null
    if (!record) return null
    const nestedErrors = record['errors'] && typeof record['errors'] === 'object' && !Array.isArray(record['errors']) ? (record['errors'] as Record<string, unknown>) : null
    const raw = record[field] ?? nestedErrors?.[field]
    const messages = Array.isArray(raw) ? raw.filter((m): m is string => typeof m === 'string') : []
    const text = messages.join(' ').trim()
    return text ? { serverError: text } : null
  }

  /**
   * Field errors stay on the form. Anything else becomes the toast message.
   */
  public static settleClonePersonaError(body: unknown, setFieldError: (value: unknown | null) => void, alertError: (message: string) => void): void {
    if (PersonaModel.validationErrorsFromFieldMessages(body, 'name') || PersonaModel.validationErrorsFromFieldMessages(body, 'slug')) {
      setFieldError(body)
      return
    }
    setFieldError(null)
    const message =
      typeof body === 'object' && body !== null && 'message' in body && typeof (body as { message: unknown }).message === 'string'
        ? (body as { message: string }).message
        : CLONE_PERSONA_ERROR
    alertError(message)
  }

  /**
   * Prefills clone name/slug using the source persona values + "copy".
   */
  public static buildCloneDefaults(name: string, slug: string): { name: string; slug: string } {
    const trimmedName = (name || '').trim()
    const trimmedSlug = PersonaModel.sanitizeSlug(slug || '')
    return {
      name: (trimmedName ? `${trimmedName} copy` : 'copy').slice(0, 255),
      slug: PersonaModel.sanitizeSlug(trimmedSlug ? `${trimmedSlug}-copy` : 'copy')
    }
  }

  /**
   * URL identifier: lowercase letters, numbers, and hyphens. Underscores become hyphens.
   * Max length matches the clone form (100).
   */
  public static sanitizeSlug(inputValue: string | null | undefined): string {
    if (!inputValue) return ''
    return inputValue
      .toLowerCase()
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .slice(0, 100)
  }
}
